import PropTypes from 'prop-types';
// @mui
import { Grid, Typography } from '@mui/material';
//
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useLocales from '../../../hooks/useLocales';
import { getPosts, setPostSearch } from '../../../redux/slices/blog/blog.post';
import BlogPostCard from './BlogPostCard';

// ----------------------------------------------------------------------

BlogPostRecent.propTypes = {
  posts: PropTypes.array.isRequired,
};

export default function BlogPostRecent() {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const { search, post, posts } = useSelector((state) => state.blogPost);

  useEffect(() => {
    handleFilterByTags(post?.tags);
    return () => handleFilterByTags(null);
  }, [post?.tags]);

  const handleFilterByTags = (tags) => {
    const tagIds = tags?.filter(t => (t.type !== 'LEVEL'))?.map(t => t.id).toString();
    dispatch(setPostSearch({ ...search, page: 0, tags, filterBys: { tagIds } }));
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getPosts());
    }, 500);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <>
      <Typography variant="h4" sx={{ mt: 10, mb: 5 }}>
        {translate('blog.others')}
      </Typography>
      <Grid container spacing={3}>
        {posts?.filter(p => (p.id !== post?.id))?.map((p) => (
          <Grid key={p.id} item xs={12} sm={6} md={3}>
            <BlogPostCard post={p} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
